import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collect_yellow",
  "use": "icon-collect_yellow-usage",
  "viewBox": "0 0 40 39",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 39\" id=\"icon-collect_yellow\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-1.4h44v44H-2z\" /><path d=\"m20 32.077-11.417 6.39a.8.8 0 0 1-1.176-.853l2.55-12.834L.35 15.896a.8.8 0 0 1 .449-1.382l12.993-1.54L19.274 1.09a.8.8 0 0 1 1.452 0l5.482 11.882L39.2 14.514a.8.8 0 0 1 .45 1.382l-9.608 8.884 2.55 12.834a.8.8 0 0 1-1.176.854L20 32.077Z\" fill=\"#F1C410\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol